import { Box, styled } from '@mui/material'

import { unit } from '@hcr/pwa/components'

import { isPwaPropValid } from '../../../../utils'

const BACKGROUND_IMAGE_BRIGHTNESS = 0.35

export const BackgroundImage = styled(Box, { shouldForwardProp: isPwaPropValid })<{
  readonly url: string
}>`
  background: linear-gradient(
      rgba(0, 0, 0, ${BACKGROUND_IMAGE_BRIGHTNESS}),
      rgba(0, 0, 0, ${BACKGROUND_IMAGE_BRIGHTNESS})
    ),
    url(${props => props.url});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-inline: ${unit(-3)};
  margin-top: ${unit(-3)};
  padding: ${unit(3)};
`
